import { memo, ReactElement, useCallback, useMemo } from "react";
import UI_MemoizedModuleDocuments from "../../../../UI_ITO/UI_ITOModuleDocuments/UI_MemoizedModuleDocuments";
import { DocumentInfo } from "../../../../UI_ITO/indexUI";
import { IAdditionalDocCardProps } from "../../../../interfaces/props/IAdditionalDocCardProps";
import {
  kkb_offer,
  kkb_processing,
  kkb_revision,
} from "../../ApplicationDetails/ApplicationTabs/config";
import AdditionalDocIcons from "./DocIcons/AdditionalDocIcons";

function AdditionalDocCard(props: IAdditionalDocCardProps): ReactElement {
  const {
    item,
    error,
    loadingDocument,
    deleteDocumentCallback,
    downloadDocumentCallback,
    Tag = null,
    status,
  } = props;
  const { document, name } = item;
  const textName = document ? document.name : "";
  const errorMessage = error || "";

  const textDownCard = useMemo(
    () => (errorMessage ? errorMessage : textName),
    [errorMessage, textName],
  );
  const isDocBolean = useMemo(
    () => (document === null || error ? false : true),
    [document, error],
  );
  const isDocSigned = !!document?.sign_file?.length;

  const onClickDownload = useCallback(() => {
    if (item?.document?.name && item?.document?.id)
      downloadDocumentCallback({
        name: item.document.name,
        document_id: item.document.id,
      });
  }, [downloadDocumentCallback, item?.document?.id, item?.document?.name]);

  const deleteDocument = useCallback(() => {
    if (deleteDocumentCallback) {
      deleteDocumentCallback({
        // В данном случае передаем id доп документа и id заявки
        document_id: item?.document?.id,
      });
    }
  }, [deleteDocumentCallback, item?.document?.id, item.id]);
  return (
    <UI_MemoizedModuleDocuments
      title={name}
      titleDown={
        <DocumentInfo
          onClick={onClickDownload}
          text={textDownCard}
          upload={isDocBolean}
        />
      }
      icon={
        <AdditionalDocIcons
          loadingDocument={loadingDocument} // Всегда загружен
          isDocBolean={isDocBolean}
          isDocSigned={isDocSigned}
          deleteDocument={deleteDocument}
          Tag={Tag}
          status={status}
          allowedStatuses={[kkb_revision, kkb_processing, kkb_offer]}
        />
      }
    />
  );
}

export default memo(AdditionalDocCard);
